import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
declare var gtag: Function; // Declarar la función gtag global
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'estadisticas-economicas-angular';

  constructor(private router: Router) {}

  ngOnInit() {
    // Escuchar los eventos de cambio de ruta
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-XGTMLHSJDS', {
          'page_path': event.urlAfterRedirects // Registrar la nueva ruta
        });
      }
    });
  }
}
